export type AnalysisListType = keyof typeof ANALYSIS_TAB_LABELS

export const ANALYSIS_TAB_LABELS: Record<string, string> = {
  all: "All",
  my_leads: "My Leads",
  buy_box: "Buy Box",
  favorites: "Favorites",
}
